import * as React from 'react';

function SvgAboutUs(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>
        <clipPath id="about_us_svg__clip-path">
          <path
            id="about_us_svg__Rectangle_303"
            d="M0 0h24v24H0z"
            data-name="Rectangle 303"
            transform="translate(116 758)"
            fill={props.fill}
            stroke="#fff"
          />
        </clipPath>
        <style>{`.about_us_svg__cls-4{fill:${props.fill}}`}</style>
      </defs>
      <g
        id="about_us_svg__about_us"
        transform="translate(-116 -758)"
        clipPath="url(#about_us_svg__clip-path)"
      >
        <g
          id="about_us_svg__about_us-2"
          data-name="about_us"
          transform="translate(-273.001 468.377)"
        >
          <path
            id="about_us_svg__Union_8"
            d="M12.025 0A12 12 0 1024 12.025 12.054 12.054 0 0012.025 0zm0 21.827a9.8 9.8 0 119.8-9.8 9.811 9.811 0 01-9.8 9.8z"
            data-name="Union 8"
            transform="translate(389.001 289.623)"
            fill={props.fill}
          />
          <path
            id="about_us_svg__Path_204"
            d="M402.044 305.386l-1.01.456 1.313-6.72a.951.951 0 00-1.414-1.01l-2.476 1.364a.961.961 0 00.96 1.666l.606-.3-1.263 6.417a1.012 1.012 0 00.96 1.162.944.944 0 00.4-.1l2.677-1.162a.962.962 0 10-.757-1.769z"
            className="about_us_svg__cls-4"
            data-name="Path 204"
            transform="translate(.599 .557)"
          />
          <path
            id="about_us_svg__Path_205"
            d="M401.259 296.567a1.364 1.364 0 10-1.359-1.367 1.358 1.358 0 001.359 1.367z"
            className="about_us_svg__cls-4"
            data-name="Path 205"
            transform="translate(.727 .281)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgAboutUs;
